<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-tabs v-model="activeName">
        <el-tab-pane label="客户信息导出" name="customer">
          <customer-export v-if="activeName === 'customer'" />
        </el-tab-pane>
        <el-tab-pane label="参会人员导出" name="meeting">
          <meeting-export v-if="activeName === 'meeting'" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import CustomerExport from './customerExport'
import MeetingExport from './meetingExport'

/**
 * 大区导出
 * 两个页签共用一个菜单 /count/areaExport，都只导出本大区管辖范围内的数据
 */
export default {
  components: {
    CustomerExport,
    MeetingExport
  },
  data() {
    return {
      activeName: 'customer'
    }
  }
}
</script>
